import React from "react";

const AppointmentsRequest = () => {
  return (
    <div>
      <h3 className="text-lg font-bold">AppointmentsRequest</h3>
      <p>Appointments Request Content goes here.</p>
    </div>
  );
};

export default AppointmentsRequest;